module.exports = __webpack_public_path__ + "static/media/branched.6f7305bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholders/branched.png
// module id = 51
// module chunks = 0